<template>
  <div class="wave-list scroll-y scroll-on-hover">
    <div class="">
      <div class="wave-items">
        <template v-for="wave in waveData?.WaveStatus" :key="wave.Id">
          <div class="wave-group">
            <WaveCard :wave="wave"
                      :is-expanded="expandedWaves.includes(wave.Name)"
                      @click="onClickToggleExpanded(wave)" />

            <!-- Render children if wave is expanded -->
            <Transition name="expand">
              <div  v-if="expandedWaves.includes(wave.Name) && wave.Children?.length > 0"
                    class="wave-children">
                <WaveCardSmall  v-for="child in wave.Children"
                                :key="child.Id"
                                :wave="child" />
              </div>
            </Transition>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import WaveCard from './WaveCard.vue';
import WaveCardSmall from './WaveCardSmall.vue';

export default {
  name: 'WaveList',

  components: {
    WaveCard,
    WaveCardSmall
  },

  data() {
    return {
      expandedWaves: []
    };
  },

  props: {
    waveData: { type: Object,  required: true }
  },

  methods: {
    onClickToggleExpanded(wave) {
      if (wave.Children?.length > 0) {
        const index = this.expandedWaves.indexOf(wave.Name);
        if (index > -1) {
          this.expandedWaves.splice(index, 1);
        } else {
          this.expandedWaves.push(wave.Name);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wave-list {
  position: relative;
  // padding-inline: 1rem;
}

.wave-items {
  display: flex;
  flex-direction: column;
  // gap: 0.75rem;
}

:root, [data-bs-theme=light] {
  .wave-group {
    &:hover :deep(.wave-card) {
      background-color: var(--custom-black-10);
    }

    .wave-children :deep(.wave-card-small:hover) {
      background-color: var(--custom-black-10);
    }
  }
}
:root.dark, [data-bs-theme="dark"] {
  .wave-group {
    &:hover :deep(.wave-card) {
      background-color: var(--custom-white-10);
    }

    .wave-children :deep(.wave-card-small:hover) {
      background-color: var(--custom-white-10);
    }
  }
}


.wave-children {
  border-left: 1px solid var(--bs-border-color);
  border-right: 1px solid var(--bs-border-color);
  border-bottom: 1px solid var(--bs-border-color);
  padding-left: 0rem;
  padding-right: 0rem;
  margin-left: 0rem;
  margin-right: 0.625rem;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 18px;
  gap: 0rem;
}

/* Expand/Collapse Animation */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.5s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  max-height: 2000px; /* Adjust based on expected content height */
  transform: translateY(0);
}
</style>
